import React, { useState, useEffect } from "react";
import axios from "axios";
import { Table } from "antd";
import { Link } from "react-router-dom";
import ConfirmatoryModal from "../ConfirmatoryModal";
import Alert from 'react-bootstrap/Alert';
import { deleteUser, getModalData } from "../../Functions/myfunctions"
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';


const UsersTable = (props) => {
    const [errorMessage, setErrorMessage] = useState("");
    const [show, setShow] = useState(true);

    const [gridData, setGridData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [modalShow, setModalShow] = React.useState(false);
    const [actionName, setActionName] = useState({ name: '', action: '' });
    const [urlLink, setUrlLink] = useState();


    useEffect(() => {
        loadData();
    }, [props.selected.key])


    const loadData = async () => {
        setLoading(true);

        axios.post(process.env.REACT_APP_BASE_URL + "/api/users/list/" + props.selected.key + "?code=" + process.env.REACT_APP_API_KEY, {
            "sessionToken": sessionStorage.getItem("sessionToken")
        }, {
            headers: {
                'Content-Type': 'application/json'
            }
        }).then(res => {
            console.log(res);
            console.log(res.data);
            setGridData(res.data);
        }).catch((error) => {
            if (error.response.data === "Access denied!") {
                sessionStorage.clear();
                window.location = "/";
            }
        });

        setLoading(false);
    }


    const confirmationfunction = (event) => {
        event.preventDefault();
        if (actionName.action === "delete") {
            deleteUser(urlLink, setErrorMessage, "reload");
        }
        setModalShow(false);
    }

    const closeAlert = () => {
        setShow(false);
        setErrorMessage("");
    }

    const modifiedData = gridData.map(({ body, ...item }) => ({
        ...item,
        key: item.RowId,
    }));

    const columns = [
        {
            title: "Név",
            dataIndex: "Name",
            align: "center",
            key: "name",
        },
        {
            title: "Felhasználónév",
            dataIndex: "UserName",
            align: "center",
            key: "username",
        },
        {
            title: "Szerepkör",
            dataIndex: "Role",
            align: "center",
            key: "role",
        },
        {
            title: "Státusz",
            dataIndex: "Active",
            align: "center",
            key: "Active",
            render: (text) => <p> {text === "1" ? "Aktív" : "Inaktív"} </p>
        },
        {
            title: "Műveletek",
            dataIndex: "RowId",
            align: "center",
            render: (text) => <div className="custom-actions">
                <OverlayTrigger
                    overlay={
                        <Tooltip id={'tooltip' + text}>
                            <strong>Szerkesztés</strong>
                        </Tooltip>
                    }
                >
                    <Link to={"/modificationuser/" + text} >
                        <div alt="edit" className="svgicon edit"></div>
                    </Link>
                </OverlayTrigger>
                <OverlayTrigger
                    overlay={
                        <Tooltip id={'tooltip' + text}>
                            <strong>Törlés</strong>
                        </Tooltip>
                    }
                >
                    <Link onClick={() => getModalData({ name: 'Kívánja a törlést végrehajtani?', action: 'delete' }, text, modalShow, setActionName, setUrlLink, setModalShow)} >
                        <div alt="delete" className="svgicon delete"></div>
                    </Link>
                </OverlayTrigger>
            </div>,
            key: "actions",
        }
    ];


    return (
        <div className="table-content">
            {errorMessage !== "" ? <Alert key="danger" variant="danger" onClose={closeAlert} dismissible>
                {errorMessage}
            </Alert> : ""}
            <Table columns={columns} dataSource={modifiedData} bordered loading={loading} id="usersTable" />
            <ConfirmatoryModal actionname={actionName} urllink={urlLink} confirmationfunction={confirmationfunction}
                show={modalShow}
                onHide={() => setModalShow(false)}
            />
        </div>
    )
};

export default UsersTable;